import React, { useState, Suspense } from 'react'
import JsonEditor from './components/JsonEditor'
import Header from './components/Header'
const AboutModal = React.lazy(() => import('./components/AboutModal'))
import './App.css'

function App() {
  const [isAboutModalOpen, setIsAboutModalOpen] = useState<boolean>(false)

  const handleAboutClick = () => {
    setIsAboutModalOpen(true)
  }

  const handleCloseAboutModal = () => {
    setIsAboutModalOpen(false)
  }

  return (
    <div className="app">
      <Header onAboutClick={handleAboutClick} />
      <main className="main-content">
        <JsonEditor />
      </main>
      <Suspense fallback={null}>
        <AboutModal isOpen={isAboutModalOpen} onClose={handleCloseAboutModal} />
      </Suspense>
    </div>
  )
}

export default App
